import * as vp from 'vopay';

type AddUserRows = {
  label: vp.AddUserLabel;
  id: vp.AddUserId;
};

const buildPermissionRows = (): AddUserRows[] => [
  {
    label: vp.AddUserLabel.EmailAddress,
    id: vp.AddUserId.EmailAddress,
  },
];

export default buildPermissionRows;
